import './overlays.css';

const KNOWN_VARIANTS = new Set(['aurora', 'frost', 'harvest', 'sparkle']);
const KNOWN_INTENSITIES = new Set(['low', 'med', 'high']);

function normalizeVariant(value: unknown): string {
  if (typeof value !== 'string') return 'none';
  const lowered = value.trim().toLowerCase();
  return KNOWN_VARIANTS.has(lowered) ? lowered : 'none';
}

function normalizeIntensity(value: unknown): string {
  if (typeof value !== 'string') return 'med';
  const lowered = value.trim().toLowerCase();
  return KNOWN_INTENSITIES.has(lowered) ? lowered : 'med';
}

export default function SeasonalBorder({ variant = 'none', intensity = 'med', embedded = false }: { variant?: string; intensity?: string; embedded?: boolean }) {
  const safeVariant = normalizeVariant(variant);
  if (safeVariant === 'none') return null;

  const safeIntensity = normalizeIntensity(intensity);
  const classes = ['seasonal-border', `seasonal-border--${safeVariant}`];
  if (embedded) classes.push('seasonal-border--embedded');

  return <div className={classes.join(' ')} data-intensity={safeIntensity} aria-hidden="true" />;
}
